import { makeStyles } from '@material-ui/core/styles'
import Lottie from 'lottie-react'
import loadingJSON from '../loading/loading.json'

const BGLoading = () => {
    const classes = useStyles()

    return (
        <div className={classes.root}>
            <div className={classes.centerPage}>
                <img
                    src={process.env.PUBLIC_URL + '/img/Chulalongkorn_University_Alt_Logo.svg.png'}
                    width={'350px'}
                    height={'auto'}
                    alt="chula"
                ></img>
                <Lottie
                    animationData={loadingJSON}
                    renderer="svg"
                    loop
                    autoplay
                    // style={{ width: '250px', height: '250px' }} //โลมา
                    style={{ width: '350px', height: '130px' }}
                />
            </div>
        </div>
    )
}

export default BGLoading

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        overflow: 'auto',
        backgroundImage: `url(${process.env.PUBLIC_URL + '/img/pink_bg.png'})`,
    },
    centerPage: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
}))
